import React from 'react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import ServiceCourse from '../service/ServiceCourse';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import BackButton from '../shared/BackButton';
import { purgeIDs } from '../../helpers/util';
import withTracker from '../withTracker';

class AdminServiceDishSelection extends React.Component {
  state = {
    isLoading: false,
    service: {},
    service_id: 0,
    menu: {
      name: '',
      courses: []
    },
    menuSelections: []
  };

  render() {
    return (
      <div className="cms menu">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton
              defaultUrl={`/admin/service/${this.state.service_id}`}
            />
            <div className="cms__bar">
              <div className="cms__bar-inputs">
                <HeadingPlaceholder
                  name="name"
                  label="Weekly Menu"
                  isEdit={false}
                  value={this.state.menu.name}
                />
              </div>
              {this.renderCTAs()}
            </div>
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">{this.renderCourses()}</div>
        </div>
      </div>
    );
  }

  renderCTAs() {
    return (
      <div className="cms__bar-ctas">
        <div className="btn btn--hollow-red-bright" onClick={this.handleCancel}>
          Cancel
        </div>
        <div className="btn btn--solid-blue" onClick={this.handleSubmit}>
          Save Selections
        </div>
      </div>
    );
  }

  renderCourses() {
    const { courses } = this.state.menu;
    // additional props for edit
    const props = {
      updateMenuSelections: this.updateMenuSelections,
      menuSelections: this.state.menuSelections,
      portion: this.state.service.portion_size || ''
    };

    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Menu</h3>
          </div>
        </div>
        {courses
          .sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1))
          .map((course, i) => (
            <ServiceCourse key={i} index={i} course={course} {...props} />
          ))}
      </div>
    );
  }

  handleCancel = () => {
    const { redirect_url, redirect_payload } = this.props.location.state;
    this.props.history.push({
      pathname: redirect_url,
      state: redirect_payload
    });
  };

  handleSubmit = () => {
    // get array of dishes to duplicate - ones without a menu_dish_id
    const dishIds = this.state.menuSelections
      .filter(this.needsSwapped)
      .map(selection => selection.dish_id);

    if (dishIds)
      this.getDishes(dishIds) // GET full dish objects in order to duplicate
        .then(this.swapDishes) // swap the dishes
        .then(this.createDishes) // create the child dishes
        .then(this.swapMenuSelections) // update the selections to use the child dishes
        .then(this.returnToService);
    // return to the service page
    else this.returnToService(this.state.menuSelections);
  };

  // get the dishes from the API
  getDishes = dishIds => {
    return Promise.all(dishIds.map(this.mapGetRequest));
  };

  // swaps the full dishes into the selection
  swapDishes = dishes => {
    if (dishes.length === 0) return [...this.state.menuSelections];

    return [...this.state.menuSelections].map(selection => {
      const dish = dishes.find(dish => selection.dish_id === dish.id);
      if (dish) selection.dish = dish;
      return selection;
    });
  };

  // create new dishes for the selections
  createDishes = menuSelections => {
    const filtered = menuSelections.filter(
      selection =>
        !selection.menu_dish_id || selection.menu_dish_id === selection.dish_id
    );
    if (filtered.length === 0) return [];

    // duplicate the dishes with Promise.Map
    return Promise.all(filtered.map(this.mapCreateRequest));
  };

  // swaps any newly created child dish into the selection, returns updated selection
  swapMenuSelections = dishes => {
    // continue if we didn't look anything up
    if (dishes.length === 0) return [...this.state.menuSelections];

    const menuSelections = [...this.state.menuSelections].map(selection => {
      if (!this.needsSwapped(selection)) return selection;

      const dish = dishes.find(
        dish => dish.parent_dish_id === selection.dish_id
      );
      if (dish) {
        selection.menu_dish_id = selection.dish_id;
        selection.dish = dish;
        selection.dish_id = dish.id;
      }

      return selection;
    });

    return menuSelections;
  };

  returnToService = menuSelections => {
    // this.setState({menuSelections});
    const { redirect_url } = this.props.location.state;

    // update the service with menu_selections
    const service = { ...this.state.service };
    service.menu_selections = menuSelections;

    this.props.history.push({
      pathname: redirect_url,
      state: { service }
    });
  };

  // filter to return selections without a menu_dish_id
  needsSwapped = selection =>
    !('menu_dish_id' in selection) || !selection.menu_dish_id;

  mapGetRequest = id => menuAPI.getDish(id);

  mapCreateRequest = selection =>
    menuAPI.createDish(this.createServiceDish(selection.dish));

  createServiceDish = dish => {
    dish.parent_dish_id = dish.parent_dish_id ? dish.parent_dish_id : dish.id;
    dish.id = null;
    dish.components = purgeIDs(dish.components);
    dish.child_private = true;
    dish.child_name = dish.child_name ? dish.child_name : ' ';

    return dish;
  };

  updateMenuSelections = menuSelections => {
    this.setState({ menuSelections });
  };

  deriveState() {
    const { state } = this.props.location;
    if (state) {
      state.service_id = state.service.id;
      state.menu = state.service.menu;
      state.menuSelections = state.service.menu_selections;
      return { ...state };
    }
    return null;
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.location !== prevProps.location) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}
export default withTracker(AdminServiceDishSelection);



// WEBPACK FOOTER //
// ./src/components/admin/AdminServiceDishSelection.js